// ─────────────────────────────────────────────────────────────────
// MEMBERSHIP PLANS — single source of truth for Free / Pro Driver /
// Company / Dispatcher. Both PricingPage and TrainingHub previously 
// hardcoded their own separate (and slightly different) copies of this list.
//
// `colorKey` is semantic, not a literal hex — each page maps it
// through its own theme object.
// ─────────────────────────────────────────────────────────────────

export const PLANS = [
  {
    id: "free",
    label: "Free Basic Member",
    icon: "🌐",
    price: "$0",
    period: "",
    colorKey: "muted",
    badge: null,
    desc: "Perfect for new users exploring PilotLinkUSA for the first time.",
    banner: {
      title: "🎉 7-Day Marketplace Access",
      body: "New members get full access to the Marketplace for 7 days before choosing a plan."
    },
    features: [
      "Browse all course listings",
      "View the public load board",
      "Basic profile listing",
      "Access demo content",
      "Community access",
      "7-day Marketplace access (full access)",
      "No credit card required to start",
    ],
    locked: [
      "Verified badge",
      "State cheat sheets",
      "Apply to loads",
      "Company tools",
      "Driver tools",
      "Marketplace access after 7 days",
    ],
    cta: "Get Started Free",
    ctaStyle: "ghost",
    to: "/signup?plan=free",
  },
  {
    id: "driver",
    label: "Pro Driver",
    icon: "👤",
    price: "$29",
    period: "/mo",
    colorKey: "blue",
    badge: "Most Popular",
    highlight: true,
    desc: "Everything a professional pilot car operator needs to get hired and grow.",
    features: [
      "Verified Driver Badge on your profile",
      "Companies can find & contact you directly",
      "Unlock all State Cheat Sheets (full access)",
      "State compliance PDFs after passing training",
      "Exclusive member pricing on all PilotLinkUSA courses",
      "Apply to unlimited loads — no limits",
      "Invoice builder + send directly to companies",
      "Priority support for professional drivers",
    ],
    note: "Already certified? Upload your cert and get verified instantly. No course required.",
    cta: "Become a Member",
    ctaStyle: "primary",
    to: "/signup?plan=driver",
  },
  {
    id: "company",
    label: "Company Plan",
    icon: "🏢",
    price: "$79",
    period: "/mo",
    colorKey: "purple",
    badge: "For Carriers",
    desc: "Hire certified drivers. Post loads. Manage your fleet from one dashboard.",
    features: [
      "Post loads instantly for only $15 per load",
      "Search our certified driver database",
      "View full driver profiles + credentials",
      "Verify driver certification status (API included)",
      "Receive & approve driver invoices in one place",
      "Export invoices to QuickBooks — ready for accounting",
      "Priority support for carriers & dispatch teams",
    ],
    cta: "Register Company",
    ctaStyle: "primary",
    to: "/signup?plan=company",
  },
  {
    id: "dispatcher",
    label: "Dispatcher Plan",
    icon: "🎧",
    price: "$59",
    period: "/mo",
    colorKey: "green",
    badge: "For Dispatch Teams",
    desc: "Built for dispatchers who need real-time visibility and complete control over every load.",
    features: [
      "Full Dispatcher Dashboard",
      "Live Order Board",
      "Real-Time GPS Tracking",
      "Route Progress & ETA Monitoring",
      "Driver Communication Tools",
      "Alerts & Notifications",
      "Document Storage",
      "Reports & Trip Logs",
      "1 Dispatcher Seat Included",
    ],
    addons: [
      "Advanced Alerts Package — +$15/mo",
      "Additional Dispatcher Seats — +$39/mo each",
      "Load Posting — $15 per load",
      "Driver Verification API — +$29/mo",
      "Fleet Management Tools — +$25/mo",
    ],
    cta: "Set Up Dispatch",
    ctaStyle: "primary",
    to: "/signup?plan=dispatcher",
  },
];

export const PLANS_BY_ID = Object.fromEntries(PLANS.map((p) => [p.id, p]));